import { render } from "./DisciplinaryCommittee.vue?vue&type=template&id=2e7e8b24&scoped=true"
import script from "./DisciplinaryCommittee.vue?vue&type=script&lang=js"
export * from "./DisciplinaryCommittee.vue?vue&type=script&lang=js"

import "./DisciplinaryCommittee.vue?vue&type=style&index=0&id=2e7e8b24&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e7e8b24"]])

export default __exports__